module.exports = __webpack_public_path__ + "static/ostromecko-ee85ad92b1ea649a5fffaa59737cf483.png";